import data from '@emoji-mart/data';

interface EmojiSkin {
	native: string;
}

interface EmojiData {
	skins: EmojiSkin[];
}

const shortcodeRegex = /(:[a-z0-9+_-]+:)(:skin-tone-\d+:)?/g;

// This is not an ideal way to do this. However, unfortuantely the front-end and back-end use two Emoji libraries
// and there are discrepancies between them as to the shortcodes used for some tokens. Until we settle on a unified
// Emoji lib we'll need to manually account for differences.
const manualAliases = {
	hugging: 'hugging_face',
	nerd: 'nerd_face',
	rofl: 'rolling_on_the_floor_laughing',
	clown: 'clown_face',
	cowboy: 'face_with_cowboy_hat',
	fox: 'fox_face',
	kiwi: 'kiwifruit',
	metal: 'the_horns',
	call_me: 'call_me_hand',
	cheese: 'cheese_wedge',
	champagne_glass: 'clinking_glasses',
} as Record<string, string>;

const registry = (data as any).emojis as unknown as Record<string, EmojiData>;
const aliases = (data as any).aliases as unknown as Record<string, string>;

const getEmojiData = (shortcode: string) => {
	const clean = shortcode.replaceAll(':', '');

	const checks = new Set([clean]);

	if (/[_-]/.test(clean)) {
		checks.add(clean.replaceAll('-', '_'));
		checks.add(clean.replaceAll('_', '-'));
	}

	const flagMatch = clean.match(/^flag[_-]([a-z]{2})$/);
	if (flagMatch) {
		checks.add(flagMatch[1]);
	}

	[aliases, manualAliases].forEach((alias) => {
		for (const variant of checks) {
			if (variant in alias) {
				checks.add(alias[variant] as string);
			}
		}
	});

	for (const name of checks) {
		if (registry[name]) {
			return registry[name];
		}
	}
};

const slackToneRegex = /:tone([1-5]):/g;

export const populateEmojis = (text: string): string => {
	return text.replaceAll(slackToneRegex, '').replaceAll(shortcodeRegex, (full, shortcode, skinTone) => {
		const emoji = getEmojiData(shortcode);
		if (!emoji) return full;
		const index = skinTone ? +skinTone.replaceAll(':', '').slice(-1) : 0;
		return emoji.skins[index]?.native || emoji.skins[0].native;
	});
};
